import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

export const PageStatusQueryRelaySpikeFragment: GraphQLTaggedNode = graphql`
	fragment PageStatusQueryRelaySpike_content on Content {
		status
	}
`;

// Dev note: If this is changed you likely need to update `PageStatusQuery` in query-preloaders-common
export const PageStatusQuery: GraphQLTaggedNode = graphql`
	query PageStatusQuery($contentId: ID!) {
		content(id: $contentId, status: ["archived", "current"]) {
			nodes {
				id
				status
			}
		}
	}
`;
